export const field_IDs_mapping = {
  // General
  FREQUENCY: {
    FREQUENCY_TYPE: "frequency_type",
    DAYS: "days",
    TIME: "time",
    TIMEZONE: "timezone",
    IGNORE_MANUAL_SCANS: "ignore_manual_scans",
  },
  SLACK: {
    SLACK_CHANNELS: "slack_channels",
  },
  MICROSOFT_TEAMS: {
    CONVERSATIONS: "conversations",
  },
  // Risk
  DETECTIONS: {
    SEVERITY_HIGH: {
      fieldID: "detections_high",
      title: "High",
      type: "checkbox",
    },
    SEVERITY_MEDIUM: {
      fieldID: "detections_medium",
      title: "Medium",
      type: "checkbox",
    },
    SEVERITY_LOW: {
      fieldID: "detections_low",
      title: "Low",
      type: "checkbox",
    },
    AFFECTING_CRITICAL_ASSET: {
      fieldID: "detection_affecting_critical_asset",
      title: "Only active detections directly affecting a critical asset",
      type: "toggle",
    },
  },
  CONTROLS: {
    CONTROLS_AND_GAPS_HIGH: {
      fieldID: "controls_high",
      title: "High",
      type: "checkbox",
    },
    CONTROLS_AND_GAPS_MEDIUM: {
      fieldID: "controls_medium",
      title: "Medium",
      type: "checkbox",
    },
    CONTROLS_AND_GAPS_LOW: {
      fieldID: "controls_low",
      title: "Low",
      type: "checkbox",
    },
    NEW_GAP: {
      fieldID: "new_gap",
      title: "New Gap detected",
      type: "toggle",
    },
    COMPLIANT_TURNED_GAP: {
      fieldID: "compliant_turned_gap",
      title: "Compliant control turned to gap",
      type: "toggle",
    },
    GAP_ESCALATED: {
      fieldID: "gap_escalated",
      title: "New misconfigured entities in existing gap",
      type: "toggle",
    },
    GAP_IMPROVED: {
      fieldID: "gap_improved",
      title: "Fewer misconfigured entities in existing gap",
      type: "toggle",
    },
    SNOOZE_ENDED: {
      fieldID: "snooze_ended",
      title: "Snooze period of control ended",
      type: "toggle",
    },
    CONTROL_ASSIGNMENT: {
      fieldID: "control_assignment",
      title: "Control assigned to member",
      type: "toggle",
    },
    GAP_TURNED_COMPLIANT: {
      fieldID: "gap_turned_compliant",
      title: "Gap turned compliant",
      type: "toggle",
    },
    NEW_COMPLIANT: {
      fieldID: "new_compliant",
      title: "New compliant control scanned",
      type: "toggle",
    },
  },
  // Scenarios
  SCENARIOS: {
    NEW_SCENARIO_SET: {
      fieldID: "new_scenario_set",
      title: "New attack paths detected",
      type: "toggle",
    },
  },
  // Assets
  CRITICAL_ASSETS: {
    CREATED_ASSET: {
      fieldID: "created_asset",
      title: "Critical asset was created",
      type: "toggle",
    },
    MODIFIED_ASSET: {
      fieldID: "modified_asset",
      title: "Critical asset was modified",
      type: "toggle",
    },
    DELETED_ASSET: {
      fieldID: "deleted_asset",
      title: "Critical asset was deleted",
      type: "toggle",
    },
    ASSET_CREATE_SUGGESTION: {
      fieldID: "asset_create_suggestion",
      title: "Suggestion for a new critical asset",
      type: "toggle",
    },
    ASSET_UPDATE_AVAILABLE: {
      fieldID: "asset_update_available",
      title: "Critical asset update available",
      type: "toggle",
    },
  },
  INTEGRATIONS: {
    INTEGRATION_CHANGES: {
      fieldID: "integration_changes",
      title: "Integration changes",
      type: "toggle",
    },
  },
  INVENTORY: {
    ENTITIES_DRIFT: "entities_drift",
  },
};
